// @flow

import type { AppType } from "shared/types/AppType"

export default ({
  asyncComponentResolve: () =>
    import("apps/customer-feedback/CustomerFeedbackEntry"),
  iconType: "team",
  name: "customer-feedback",
  requirePermission: "rating:view"
}: AppType)
